import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { HeaderTop } from './HeaderTop.js';
const BG_COLOR_TO_BLOCK_VERSION = {
    'bg-white': 'primary',
    transparent: 'transparent',
};
export const Header = UniBlock(({ bgColor = 'bg-white', alwaysShowLogo = false, version = BG_COLOR_TO_BLOCK_VERSION[bgColor], portal, logo: customLogo = {}, ...rest }) => {
    const { backwardButton, logo = {} } = rest.options?.page?.common ?? {};
    const { internetBankButton } = portal || {};
    const logoProps = customLogo.image?.icon || customLogo.image?.src ? customLogo : logo;
    return (_jsx(BlockWrapper, { tag: "header", defaultPadding: "", version: version, ...rest, children: _jsx("div", { className: "container px-lg py-2xs box-border", children: _jsx(HeaderTop, { bgColor: bgColor, logo: logoProps, alwaysShowLogo: alwaysShowLogo, internetBankButton: internetBankButton, version: version, backwardButton: backwardButton, ...rest }) }) }));
});
//# sourceMappingURL=Header.js.map